import React from 'react';
import style from '../../css/InfoList.module.css';
import { FaBookOpen, FaCalculator, FaMapMarked, FaUser } from 'react-icons/fa';

function ComInfo() {
	const data = [
		{
			id: 0,
			title: 'Best Education',
			icon: <FaBookOpen />,
		},
		{
			id: 1,
			title: 'Qualified Staff',
			icon: <FaUser />,
		},
		{
			id: 2,
			title: 'Affordable',
			icon: <FaCalculator />,
		},
		{
			id: 3,
			title: 'Friendly Place',
			icon: <FaMapMarked />,
		},
	];

	return (
		<div className={style.info}>
			{data.map((item) => {
				return (
					<div className={style.coloum} key={item.id}>
						<div className={style.icon}>{item.icon}</div>
						<p className={style.title}>{item.title}</p>
					</div>
				);
			})}
		</div>
	);
}

export default ComInfo;
